export default __webpack_public_path__ + "static/media/cat20.6fd57b76.gif";